import React, { useEffect } from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import { syncUser } from '../helpers/asyncActions';
import { useGlobalContext } from '../stores/global';

interface Props extends Omit<RouteProps, 'component'> {
  component: React.ComponentType<any>;
}

export default function ProtectedRoute({
  component: Component,
  ...rest
}: Props) {
  const { user, dispatch } = useGlobalContext();

  useEffect(() => {
    syncUser(dispatch, true);
  }, []);

  return (
    <Route
      {...rest}
      render={(props) =>
        user ? <Component {...props} /> : <Redirect to="/" />
      }
    />
  );
}
